export function useRounding(significance: number) {
  const WHOPPING_BIG = 10 ** 6;

  function roundExponential(x: number): string {
    if (Math.abs(x) >= WHOPPING_BIG) {
      // this uses negative lookbehind:
      // the string of zeros must not be preceded by the decimal point
      // (otherwise we might end up with things like "7.e+6")
      return x.toExponential(significance).replace(/(?<!\.)0+e/, "e"); // 1.2345e+6
    }
    if (parseInt(x.toString()) === x) {
      return x.toString();
    }
    if (Math.abs(x) < 10 ** -significance) {
      // uses negative lookbehind
      return x.toExponential(significance).replace(/(?<!\.)0+e/, "e"); // 1.234e-4; 1.234e-5
    }
    if (Math.abs(x) < 1) {
      return x.toPrecision(significance).replace(/0+$/, ""); // 0.123; 0.0123; 0.00123
    }
    return x.toFixed(significance).replace(/0+$/, ""); // 12.345; 1.234
  }

  return {
    roundExponential,
  };
}
